import React from 'react';
import { LatestDetection } from '../../../../LiveContext/SessionContext/SessionDetectionContextProvider/useSessionDetectionContext';

export interface DetectionGroup {
  id: string,
  title: string,
  lastOccurrence: number,
  projectId: string;
  detections: (LatestDetection & { cardTitle: string, commandTitle: string })[],
  displayedAt?: number,
  notificationBadge?: { seen: boolean },
}

const DetectionGroupContext = React.createContext<DetectionGroup[] | null>(null);

export default DetectionGroupContext;
